






import { useSave } from '@/composables';
import { BaseModuleEditor } from '../base';
import { ElementScreenshareMeta } from '@fillip/api';

export default {
  name: 'ScreenshareEditor',
  mixins: [BaseModuleEditor],
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  setup(props: any) {
    const { buffer, save } = useSave(props, {
      path: 'element',
      defaultValue: ElementScreenshareMeta.default,
    });

    return {
      buffer,
      save,
    };
  },
};
